import styled from "styled-components";

export const NovaSolicitacaoTitle = styled.h1`
  color: ${(props) => props.color};
  font-size: 24px;
`;

export const ContainerNovaSolicitacao = styled.div`
  max-width: 100%;
  // border: 2px solid #d1d1d1;
  border-radius: 4px;
  .acompanharSolicitacao {
    cursor: pointer;
  }
`;

export const Header = styled.div`
  // padding: 8px 16px;
  background-color: ${(props) => props.bg};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  span {
    color: #ffffff;
    font-size: 14px;
  }
`;

export const Body = styled.div`
  // padding: 8px 16px;
`;

export const Subtitle = styled.span`
  color: #4d4d4d;
  margin-bottom: 48px;
  display: block;
  font-size: 16px;
  line-height: 24px;
`;
